import './header.css'
import React from 'react'
import { useSetRecoilState } from 'recoil'
import { sidebarDisp_ } from '../../../data/atom'
import noti from '../../../assets/images/noti.png'
import logout from '../../../assets/images/logout.png'
import search from '../../../assets/images/search.png'
import add from '../../../assets/images/add.png'
import hamburger from '../../../assets/images/hamburger.png'
import { useLocation } from 'react-router-dom'
import { useHistory } from 'react-router-dom'

function Header() {
    const history = useHistory();
    const location = useLocation();
    const setSidebarDisp = useSetRecoilState(sidebarDisp_)
    const logoutHandle = () => {
        sessionStorage.removeItem('authData')
        history.push('/sign-in')
    }
    return (
        <div className='header-admin'>
            <nav className='nav-bar'>
                <div className='nav-bar-child1'>
                    <div className='nav-bar-hamburger' onClick={() => setSidebarDisp("block")}>
                        <img src={hamburger} alt="" />
                    </div>
                    <div className='input-header-admin'>
                        <input
                            type="text"
                            placeholder='Search' />
                        <img src={search} alt="" />
                    </div>
                </div>
                <div className='nav-child-2'>
                    {location.pathname === "/dashboard" ?
                        <div className='nav-buttons'>
                            <button onClick={() => history.push('/add-load')} style={{ background: '#FF7B00', marginRight: '15px' }}><img src={add} alt="" />  Add Load</button>
                            <button style={{ background: '#00446B' }}><img src={add} alt="" />  Create Invoive</button>
                        </div> : ''
                    }
                    <div className="noti-icon"> <img src={noti} alt="" /></div>
                    <div className="noti-icon"> <img onClick={logoutHandle} src={logout} alt="" /></div>
                </div>
            </nav>
        </div>
    )
}

export default Header